import { Command1 } from "../../../../../Command";
import { GetSensorsDataForIncidentFn, SensorsDataResult } from "../../../../../rest/Geotab";
import { ValueActions } from "../../../../flux/Value/ValueActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { Key } from "../../../../../models";

export class FindIncidentDataCommand implements Command1<Key>
{
    private readonly valueActions = new ValueActions<Key>();
    private readonly errorActions = new ErrorActions();

    private token: Key;
    
    constructor(private getSensorsDataForIncident: GetSensorsDataForIncidentFn, private showSensorsDataCmd: Command1<SensorsDataResult>, private valueDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = (incidentId: Key) => {
        this.token = incidentId;
        this.valueActions.set(incidentId, this.valueDispatchToken);

        const sameToken = () => this.token === incidentId;
        this.getSensorsDataForIncident(incidentId)
            .then(res => {
                if(sameToken()) {
                    return this.showSensorsDataCmd.execute(res);
                }
            })
            .catch(err => sameToken() && this.errorActions.setError(err, this.errorDispatchToken, 5 * 1000))
            .then(() => {
                if(sameToken()) {
                    this.token = null;
                    this.valueActions.clear(this.valueDispatchToken);
                }
            }); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/commands/FindIncidentDataCommand.ts